function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "01871234-c547-4dad-9a9e-117fcc2bb7d8",
  x1: 660.5,
  y1: 458.72,
  x2: 660.5,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), React.createElement("linearGradient", {
  id: "705039c9-bbaf-489f-8754-0d88ff1d230d",
  x1: 802.94,
  y1: 120.14,
  x2: 802.94,
  y2: 40.02,
  xlinkHref: "#01871234-c547-4dad-9a9e-117fcc2bb7d8"
}), React.createElement("linearGradient", {
  id: "f1b18cc7-88bb-4220-8574-cb67e65e6847",
  x1: 802.94,
  y1: 269.14,
  x2: 802.94,
  y2: 189.02,
  xlinkHref: "#01871234-c547-4dad-9a9e-117fcc2bb7d8"
}), React.createElement("linearGradient", {
  id: "729136a4-2a29-4999-b297-e6b2d53009e3",
  x1: 802.94,
  y1: 417.14,
  x2: 802.94,
  y2: 337.02,
  xlinkHref: "#01871234-c547-4dad-9a9e-117fcc2bb7d8"
}), React.createElement("linearGradient", {
  id: "7a22862c-2f66-4029-a70d-d91858435973",
  x1: 475.1,
  y1: 785.18,
  x2: 475.1,
  y2: 418.21,
  xlinkHref: "#01871234-c547-4dad-9a9e-117fcc2bb7d8"
}), React.createElement("linearGradient", {
  id: "668716b8-0ce2-4b29-be6e-2467fe221975",
  x1: 475.5,
  y1: 810.19,
  x2: 475.5,
  y2: 750.5,
  xlinkHref: "#01871234-c547-4dad-9a9e-117fcc2bb7d8"
}), React.createElement("linearGradient", {
  id: "032f3a0d-ef41-4ad6-8a52-90e2f3059f59",
  x1: 459.55,
  y1: 723.31,
  x2: 459.55,
  y2: 473.18,
  xlinkHref: "#01871234-c547-4dad-9a9e-117fcc2bb7d8"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "secure server");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.8
}, React.createElement("rect", {
  x: 455,
  width: 411,
  height: 458.72,
  fill: "url(#01871234-c547-4dad-9a9e-117fcc2bb7d8)"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("rect", {
  x: 461.79,
  y: 306.27,
  width: 397.41,
  height: 142.46,
  fill: "#fff"
});

var _ref6 =
/*#__PURE__*/
React.createElement("rect", {
  x: 494.41,
  y: 340.06,
  width: 15.4,
  height: 73,
  fill: "#64ffda"
});

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.7
}, React.createElement("rect", {
  x: 524.81,
  y: 340.06,
  width: 15.4,
  height: 73,
  fill: "#64ffda"
}));

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.6
}, React.createElement("rect", {
  x: 555.22,
  y: 340.06,
  width: 15.4,
  height: 73,
  fill: "#64ffda"
}));

var _ref9 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.5
}, React.createElement("rect", {
  x: 585.62,
  y: 340.06,
  width: 15.4,
  height: 73,
  fill: "#64ffda"
}));

var _ref10 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.5
}, React.createElement("rect", {
  x: 616.02,
  y: 340.06,
  width: 15.4,
  height: 73,
  fill: "#64ffda"
}));

var _ref11 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.4
}, React.createElement("rect", {
  x: 646.42,
  y: 340.06,
  width: 15.4,
  height: 73,
  fill: "#64ffda"
}));

var _ref12 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.3
}, React.createElement("rect", {
  x: 676.83,
  y: 340.06,
  width: 15.4,
  height: 73,
  fill: "#64ffda"
}));

var _ref13 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 802.94,
  cy: 376.09,
  r: 37.16,
  fill: "#03a9f4"
});

var _ref14 =
/*#__PURE__*/
React.createElement("rect", {
  x: 461.79,
  y: 158.26,
  width: 397.41,
  height: 142.46,
  fill: "#fff"
});

var _ref15 =
/*#__PURE__*/
React.createElement("rect", {
  x: 494.41,
  y: 192.05,
  width: 15.4,
  height: 73,
  fill: "#64ffda"
});

var _ref16 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.7
}, React.createElement("rect", {
  x: 524.81,
  y: 192.05,
  width: 15.4,
  height: 73,
  fill: "#64ffda"
}));

var _ref17 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.6
}, React.createElement("rect", {
  x: 555.22,
  y: 192.05,
  width: 15.4,
  height: 73,
  fill: "#64ffda"
}));

var _ref18 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.5
}, React.createElement("rect", {
  x: 585.62,
  y: 192.05,
  width: 15.4,
  height: 73,
  fill: "#64ffda"
}));

var _ref19 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.5
}, React.createElement("rect", {
  x: 616.02,
  y: 192.05,
  width: 15.4,
  height: 73,
  fill: "#64ffda"
}));

var _ref20 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.4
}, React.createElement("rect", {
  x: 646.42,
  y: 192.05,
  width: 15.4,
  height: 73,
  fill: "#64ffda"
}));

var _ref21 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.3
}, React.createElement("rect", {
  x: 676.83,
  y: 192.05,
  width: 15.4,
  height: 73,
  fill: "#64ffda"
}));

var _ref22 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 802.94,
  cy: 228.09,
  r: 37.16,
  fill: "#03a9f4"
});

var _ref23 =
/*#__PURE__*/
React.createElement("rect", {
  x: 461.79,
  y: 10.25,
  width: 397.41,
  height: 142.46,
  fill: "#fff"
});

var _ref24 =
/*#__PURE__*/
React.createElement("rect", {
  x: 494.41,
  y: 44.05,
  width: 15.4,
  height: 73,
  fill: "#64ffda"
});

var _ref25 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.7
}, React.createElement("rect", {
  x: 524.81,
  y: 44.05,
  width: 15.4,
  height: 73,
  fill: "#64ffda"
}));

var _ref26 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.6
}, React.createElement("rect", {
  x: 555.22,
  y: 44.05,
  width: 15.4,
  height: 73,
  fill: "#64ffda"
}));

var _ref27 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.5
}, React.createElement("rect", {
  x: 585.62,
  y: 44.05,
  width: 15.4,
  height: 73,
  fill: "#64ffda"
}));

var _ref28 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.5
}, React.createElement("rect", {
  x: 616.02,
  y: 44.05,
  width: 15.4,
  height: 73,
  fill: "#64ffda"
}));

var _ref29 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.4
}, React.createElement("rect", {
  x: 646.42,
  y: 44.05,
  width: 15.4,
  height: 73,
  fill: "#64ffda"
}));

var _ref30 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.3
}, React.createElement("rect", {
  x: 676.83,
  y: 44.05,
  width: 15.4,
  height: 73,
  fill: "#64ffda"
}));

var _ref31 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 802.94,
  cy: 80.08,
  r: 40.06,
  fill: "url(#705039c9-bbaf-489f-8754-0d88ff1d230d)"
});

var _ref32 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 802.94,
  cy: 229.08,
  r: 40.06,
  fill: "url(#f1b18cc7-88bb-4220-8574-cb67e65e6847)"
});

var _ref33 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 802.94,
  cy: 377.08,
  r: 40.06,
  fill: "url(#729136a4-2a29-4999-b297-e6b2d53009e3)"
});

var _ref34 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 802.94,
  cy: 80.08,
  r: 37.16,
  fill: "#03a9f4"
});

var _ref35 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.8
}, React.createElement("path", {
  d: "M750.13,785.18H200.07V434a15.8,15.8,0,0,1,15.8-15.8H734.32a15.8,15.8,0,0,1,15.8,15.8Z",
  transform: "translate(-167 -89.81)",
  fill: "url(#7a22862c-2f66-4029-a70d-d91858435973)"
}));

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  d: "M56.45,334.85h503.3a15.8,15.8,0,0,1,15.8,15.8V695.37a0,0,0,0,1,0,0H40.65a0,0,0,0,1,0,0V350.65A15.8,15.8,0,0,1,56.45,334.85Z",
  fill: "#fff"
});

var _ref37 =
/*#__PURE__*/
React.createElement("rect", {
  x: 57.87,
  y: 355.82,
  width: 500.46,
  height: 328.25,
  fill: "#f5f5f5"
});

var _ref38 =
/*#__PURE__*/
React.createElement("rect", {
  x: 59.79,
  y: 371.76,
  width: 498.34,
  height: 295.32,
  fill: "#e0e0e0",
  opacity: 0.8
});

var _ref39 =
/*#__PURE__*/
React.createElement("rect", {
  x: 59.79,
  y: 356.07,
  width: 498.34,
  height: 15.69,
  fill: "#f5f5f5"
});

var _ref40 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 70.47,
  cy: 363.67,
  r: 3.8,
  fill: "#ff5252"
});

var _ref41 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 80.93,
  cy: 363.67,
  r: 3.8,
  fill: "#ff0"
});

var _ref42 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 91.4,
  cy: 363.67,
  r: 3.8,
  fill: "#69f0ae"
});

var _ref43 =
/*#__PURE__*/
React.createElement("text", {
  x: -167,
  y: -89.81
});

var _ref44 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.8
}, React.createElement("path", {
  d: "M765.52,808.77c-30.62,2.32-556.46,1.39-574.84,0C166.59,797.16,167,752.12,167,752.12l241.15-1.61.81,13.71H512.2l4-12.1H783.48S788.79,793.45,765.52,808.77Z",
  transform: "translate(-167 -89.81)",
  fill: "url(#668716b8-0ce2-4b29-be6e-2467fe221975)"
}));

var _ref45 =
/*#__PURE__*/
React.createElement("path", {
  d: "M779.56,755.75H517.5a8,8,0,0,1-6.11,13.31h-100a8,8,0,0,1-6.11-13.31H170.63s-.4,39.12,23.39,49.2c18.15,1.21,537.56,2,567.8,0C784.81,791.64,779.56,755.75,779.56,755.75Z",
  transform: "translate(-167 -89.81)",
  fill: "#f5f5f5"
});

var _ref46 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 58.07,
  cy: 674.4,
  r: 3.23,
  fill: "#e0e0e0"
});

var _ref47 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 67.75,
  cy: 674.4,
  r: 3.23,
  fill: "#e0e0e0"
});

var _ref48 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 77.43,
  cy: 674.4,
  r: 3.23,
  fill: "#e0e0e0"
});

var _ref49 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.7
}, React.createElement("path", {
  d: "M459.55,473.18l-97.06,59.73s0,123.2,97.06,190.39c97.06-67.2,97.06-190.39,97.06-190.39Z",
  transform: "translate(-167 -89.81)",
  fill: "url(#032f3a0d-ef41-4ad6-8a52-90e2f3059f59)"
}));

var _ref50 =
/*#__PURE__*/
React.createElement("path", {
  d: "M459.55,480.23,368,536.6s0,116.26,91.6,179.67c91.6-63.41,91.6-179.67,91.6-179.67Z",
  transform: "translate(-167 -89.81)",
  fill: "#03a9f4"
});

var _ref51 =
/*#__PURE__*/
React.createElement("path", {
  d: "M461.11,480.23l-1.57,1v234l1.57,1.1c91.6-63.41,91.6-179.67,91.6-179.67Z",
  transform: "translate(-167 -89.81)",
  opacity: 0.05
});

var _ref52 =
/*#__PURE__*/
React.createElement("path", {
  d: "M459.55,493.85l-81,49.86s0,102.84,81,158.94c81-56.1,81-158.94,81-158.94Z",
  transform: "translate(-167 -89.81)",
  fill: "#03a9f4"
});

var _ref53 =
/*#__PURE__*/
React.createElement("path", {
  d: "M459.55,494.24V703c81-56.1,81-158.94,81-158.94Z",
  transform: "translate(-167 -89.81)",
  opacity: 0.08
});

var _ref54 =
/*#__PURE__*/
React.createElement("polyline", {
  points: "239 306.38 239 99.38 410 99.38",
  fill: "none",
  stroke: "#3ad29f",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  strokeDasharray: 12
});

var _ref55 =
/*#__PURE__*/
React.createElement("polyline", {
  points: "186 243.38 186 36.38 357 36.38",
  fill: "none",
  stroke: "#3ad29f",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  strokeDasharray: 12
});

var _ref56 =
/*#__PURE__*/
React.createElement("polyline", {
  points: "716 477.38 716 639.38 626 639.38",
  fill: "none",
  stroke: "#3ad29f",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  strokeDasharray: 12
});

var _ref57 =
/*#__PURE__*/
React.createElement("polyline", {
  points: "770 513.38 770 675.38 680 675.38",
  fill: "none",
  stroke: "#3ad29f",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  strokeDasharray: 12
});

var SvgSecureServer = function SvgSecureServer(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "4687a0c2-bd42-4093-8bbc-92d10a889ded",
    "data-name": "Layer 1",
    width: 866,
    height: 720.37,
    viewBox: "0 0 866 720.37",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSecureServer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SecureServer.5197f8f6.svg";
export { ForwardRef as ReactComponent };